import { styled } from '@mui/material/styles';
import { Typography, AccordionSummary, Accordion, SvgIcon } from '@mui/material';
import { DS_typography as coreTypography } from '../../../base/theme/DS_Tokens/core';

export const AccordionStyled = styled(Accordion)(
  ({ theme }) => `
    border-radius: 12px !important;
    border: 1px solid #F8F8F8;
    background: ${theme.DS_palette.primary.white};
    box-shadow: 5px 17px 32px 0px rgba(0, 0, 0, 0.07) !important;
    padding: ${theme.DS_spacing(['md'])};
    margin-bottom: 12px;
    &::before {
      display: none;
    }
  `,
);

export const InfoContainer = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const dynamicpaddingExtentedStyles = ({ theme, $expandedAlways }) =>
  $expandedAlways
    ? `
    padding-top: ${theme.DS_spacing(['sm'])};
  `
    : `
    padding-top: 0;
  `;

export const InfoList = styled('section')(
  ({ theme, $expandedAlways }) => `
  text-align: left;
  width: 100%;
   
  li {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  } 
    
  ${dynamicpaddingExtentedStyles({ theme, $expandedAlways })}
`,
);

export const StyledInfo = styled('span')(
  ({ theme }) => `
    color: ${theme.DS_palette.text.secondary};
    
    p {
      font-size: ${coreTypography.fontSize.lvl3};
      font-style: normal;
      font-weight: ${coreTypography.fontWeight.medium};
      line-height: ${coreTypography.lineHeight.lvl5};
      word-break: break-word;
    }
    a {
      text-decoration: none;
      font-style: normal;
      font-weight: ${coreTypography.fontWeight.bold};
    }
  `,
);

export const ExpandMoreIconStyled = styled(SvgIcon)(
  ({ theme }) => `
   fill: ${theme.DS_palette.buttons.enabled};
   width: ${theme.DS_spacing(['xs'])} !important;
   height: ${theme.DS_spacing(['xs'])} !important;
`,
);

const dynamicDisplay = ({ $expandedAlways }) =>
  $expandedAlways
    ? `
   display: none;
  `
    : `
   display: flex;
  `;

export const AccordionSummaryStyled = styled(AccordionSummary)(
  ({ theme }) => `
    ${dynamicDisplay};
    min-height: auto !important;
  
    svg {
      width: 32px;
      height: 32px;
    }
    .MuiAccordionSummary-content {
      margin: 0;
    }
    .MuiAccordionSummary-expandIconWrapper {
      margin-left: ${theme.DS_spacing(['xs'])};
    }
    
    ${theme.breakpoints.up('md')} {
      .MuiAccordionSummary-expandIconWrapper {
        margin-left: 40px;
      }
    }
  `,
);

export const LabelStyled = styled(Typography)(
  ({ theme, $expandedAlways }) => `
  color: ${theme.DS_palette.primary.black};
  ${dynamicDisplay({ $expandedAlways })};
`,
);
